import * as React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useAppSelector } from "../app/hooks";


export const ProductionCard: React.FC = () => {
    const bestAvailableModel = useAppSelector((state) => state.bestAvailableModel);
    const [currentProduction, setCurrentProduction] = useState(bestAvailableModel.production);
    const [currentPerformance, setCurrentPerformance] = useState(bestAvailableModel.currentPerformance);

    useEffect(() => { setCurrentProduction(bestAvailableModel.production) }, [bestAvailableModel.production])
    useEffect(() => { setCurrentPerformance(bestAvailableModel.currentPerformance) }, [bestAvailableModel.currentPerformance])

    return (
        <article className="preview-card-main preview-card-main-with-header theme-dark" style={{ backgroundImage: "url(" + currentProduction.imageUrl + ")" }}>
            {
                !bestAvailableModel.hidePerformanceAvailability && currentPerformance ?
                <div className="preview-card-main-header preview-card-main-availability">
                    <p className={`availability-${currentPerformance.availabilityClass}`}>{currentPerformance.availabilityIndicatorText}</p>
                    </div>
                : null
            }
            <div className="preview-card-details stack-lg">
                <div>
                    <h2 dangerouslySetInnerHTML={{ __html: currentProduction.productionTitle }}></h2>
                </div>
                <div>
                    <p>{currentProduction.dateRange}</p>
                    {
                        currentProduction.venueDescription &&
                        <p>{currentProduction.venueDescription}</p>
                    }
                </div>
            </div>
        </article>
    )
}